import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FatherService } from './father.service';
import {HttpClient} from "@angular/common/http";
import {LocalstorageService} from "./localstorage.service";

@Injectable({
  providedIn: 'root'
})
export class TwoFactorService extends FatherService {

  generate2fa$ = new Subject<void>();

  constructor(
    httpClient: HttpClient,
    localstorageService: LocalstorageService
  ) {
    super(httpClient, localstorageService);
  }

  // Получаем секрет и QR-код
  generate2FA(): Observable<any> {
    return this.get('/api-base/2fa/generate');
  }

  // Отправляем введённый пользователем токен для проверки
  verify2FA(token: string): Observable<any> {
    return this.post('/api-base/2fa/verify', { token });
  }

  // Сброс 2FA для пользователя
  drop2fa(userUuid: string): Observable<any> {
    return this.post('/api-base/2fa/drop', { userUuid });
  }
}
